define(['jquery', 'erv_tracking', 'erv_framework', 'forms'], function ($, Tracking, ERVFramework, Forms) {

	var ERVClaimsContainer = function() {
		var self = this;
		self.tracking = new Tracking();
		self.framework = new ERVFramework();
		self.forms = new Forms();

		self.$ervBody = $('#erv-body');

		self.initLoadSaveForLater = function() {
			var claimsGuid = self.getUrlParameter('claimsGuid');

			if (!claimsGuid) {
				return false;
			}

			self.framework.popup.openPopup(
				'#popup-loadsaveddata',
				{
					elementParse: function(item) {
						var $popup = $(item.src);
						$popup.removeClass('hide');

						$popup.find('[data-js="ok"]').on('click', function(e) {
							e.preventDefault();

							$.magnificPopup.close();				

							(() => import('auth')
							.then(auth => auth.default())
							.then(auth => {
								var redirect = false;

								auth.login(function (token) {

									self.forms.activateLoading($('body'), false);

									$.ajax({
										type: 'GET',
										url: '/col/load-save-for-later',
										data: { claimsGuid: claimsGuid },
										headers: { 'Authorization': token },
										success: function(data) {
											if (data && data.status) {
												redirect = true;
												self.tracking.trackEvent('Claims', 'LoadSaveForLater', null, null, function() {
													window.location.replace(data.redirect);
												});
											}
										}
									}).done(function() {
										if (!redirect) {
											self.forms.deactivateLoading($('body'));
										}
									});
								},
								function(error) {
									self.framework.initGenericAlert(error);
									self.forms.deactivateLoading($('body'));
								});
							}))();
						});

						$popup.find('[data-js="notok"]').on('click', function(e) {
							e.preventDefault();
							$.magnificPopup.close();
						});
					}
				},
				true,
				false
			);
		}

		self.getUrlParameter = function(sParam) {
			var sPageURL = decodeURIComponent(window.location.search.substring(1)),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : sParameterName[1];
				}
			}
		};
	};

	ERVClaimsContainer.prototype.init = function () {
		var self = this;

		self.initLoadSaveForLater();
	}

	return ERVClaimsContainer;
});